import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { vendorsService } from "@/services/api/cresivoxServer";


import { REDUCER_NAME, iVendorWithShopDTO} from './Types';
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);


export const addVendors = createAsyncThunk<
iGenericResponse<any | null> | null,
iVendorWithShopDTO,
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("addVendors"),
// @ts-expect-error
async (payload, {rejectWithValue}) => {
	try {
		const response = await vendorsService.addVendors(payload);
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								orders: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);



export const updateVendorStatus = createAsyncThunk<
iGenericResponse<any | null> | null,
{ vendorId: string; data: { status: number } },
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateVendorStatus"),
// @ts-expect-error
async ({ vendorId, data }, {rejectWithValue}) => {
	try {
		const response = await vendorsService.updateVendorStatus(vendorId, data);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


export const getvendorsList = createAsyncThunk<
  iGenericResponse<any | null> | null,
{ page?: number; limit?: number; search?: string } | void,
  {
	  rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getvendorsList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
	  try {
      const page = arg && typeof arg === 'object' ? arg.page : undefined;
      const limit = arg && typeof arg === 'object' ? arg.limit : undefined;
      const search = arg && typeof arg === 'object' ? arg.search : undefined;
		  const response = await vendorsService.getvendorsList(page, limit, search);
		  if (response) {
			  const {httpStatusCode, data, message} = response;

			  switch (httpStatusCode) {
				  case httpStatusCodes.SUCCESS_OK: {
					  if (data && data.data) {
						  return {
							data:{
							  httpStatusCode,
							  data: data.data,
							  message,
							}
						  };
					  } else {
						  return rejectWithValue({
							  httpStatusCode,
							  message,
						  });
					  }
				  }
				  default: {
					  return rejectWithValue({
						  httpStatusCode,
						  message,
					  });
				  }
			  }
		  } else {
			  return rejectWithValue({
				  message: "No response received",
			  });
		  }
	  } catch (error) {
		  return rejectWithValue({
			  message: "Something went wrong",
		  });
	  }
  },
);


export const getVendorProductsList = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
	  rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getVendorProductsList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async ({ status }, {rejectWithValue}) => {
	  try {
		  const response = await vendorsService.getVendorProductsList(status);
		  if (response) {
			  const {httpStatusCode, data, message} = response;

			  switch (httpStatusCode) {
				  case httpStatusCodes.SUCCESS_OK: {
					  if (data && data.data) {
						  return {
							data:{
							  httpStatusCode,
							  data: data.data,
							  message,
							}
						  };
					  } else {
						  return rejectWithValue({
							  httpStatusCode,
							  message,
						  });
					  }
				  }
				  default: {
					  return rejectWithValue({
						  httpStatusCode,
						  message,
					  });
				  }
			  }
		  } else {
			  return rejectWithValue({
				  message: "No response received",
			  });
		  }
	  } catch (error) {
		  return rejectWithValue({
			  message: "Something went wrong",
		  });
	  }
  },
);






